import { render } from "./Dashboard.vue?vue&type=template&id=1b90521c"
import script from "./Dashboard.vue?vue&type=script&lang=js"
export * from "./Dashboard.vue?vue&type=script&lang=js"

import "./Dashboard.vue?vue&type=style&index=0&id=1b90521c&lang=css"
script.render = render

export default script